module.exports = __webpack_public_path__ + "./images/layers.svg";